import { render } from "./PendingAccounts.vue?vue&type=template&id=74cb204a&scoped=true&ts=true"
import script from "./PendingAccounts.vue?vue&type=script&lang=ts"
export * from "./PendingAccounts.vue?vue&type=script&lang=ts"

import "./PendingAccounts.vue?vue&type=style&index=0&id=74cb204a&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74cb204a"]])

export default __exports__